module.exports = __webpack_public_path__ + "static/logo-ed40751a4239b6038f48405670d33ff7.png";